import styled from 'styled-components'

import iconCalendar from '../../../../assets/images/icon_calendar.svg'
import iconExpand from '../../../../assets/images/icon_expand.svg'
import { useBuildingContext } from '../../../../contexts/buildingContext'
import { media } from '../../../../styles/breakpoints'
import { Icon } from '../../../common/Icon'
import { LoadingIndicator } from '../../../common/LoadingIndicator'

const PreviewPopupBase = styled.div`
  right: 0;
  top: 24px;
  position: absolute;

  width: 400px;
  filter: drop-shadow(0px 5px 30px rgba(0, 0, 0, 0.25));

  @media ${media.belowTablet} {
    position: fixed;
    left: 0;
    right: 0;
    top: auto;
    bottom: 0;
    width: 100%;
    max-width: none;
    margin: 0;
    z-index: 200;
    filter: drop-shadow(0px -4px 24px rgba(0, 0, 0, 0.15));
    padding-bottom: env(safe-area-inset-bottom, 0px);
  }
`

const HEADER_MUTED = '#7e858e'

const PreviewPopupHeader = styled.div`
  height: 40px;
  background-color: white;

  display: flex;
  align-items: center;
  justify-content: space-between;

  font-size: 16px;
  line-height: 16px;

  color: ${HEADER_MUTED};

  padding: 0 12px 0 8px;
  border-radius: 2px 2px 0 0;
`

const HeaderDate = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
  min-width: 0;
  font-size: 16px;
  line-height: 16px;
`

const CloseButton = styled.button.attrs({
  type: 'button',
  'aria-label': 'Close',
})`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: none;
  border: none;
  padding: 8px;
  margin: 0;
  cursor: pointer;
  min-width: 44px;
  min-height: 44px;
  color: ${HEADER_MUTED};
`

const CloseIcon = styled.svg`
  width: 16px;
  height: 16px;
  display: block;
  flex-shrink: 0;
`

const imageStyles = `
  height: 220px;
  max-width: 100%;
  border-radius: 0 0 2px 2px;
  background-color: white;
`

const PreviewPopupImage = styled.img`
  ${imageStyles}
  object-fit: cover;
  display: block;
`

const EmptyPreviewPopupImage = styled.div`
  ${imageStyles}
  display: flex;
  justify-content: center;
  align-items: center;
`

const PreviewPopupImageWrap = styled.div`
  position: relative;
`

const PreviewPopupIconButton = styled.div`
  position: absolute;
  bottom: 8px;
  right: 8px;

  background-color: white;
  padding: 8px;
  min-width: 44px;
  min-height: 44px;
  box-shadow: 0 1px 20px rgba(0, 0, 0, 0.1);
  border-radius: 2px;

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;
`

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export const PreviewPopup = (props: {
  onFullScreenClick: () => void
  onClose: () => void
  imageLoading: boolean
}) => {
  const { state: buildingState } = useBuildingContext()

  let takenOn
  let imageUrl
  let day
  let months
  let month
  let year

  if (
    !props.imageLoading &&
    buildingState.imageData &&
    buildingState.imageData.data
  ) {
    takenOn = buildingState.imageData.data.taken_on
    imageUrl = buildingState.imageData.image

    day = new Date(takenOn).getDate()
    months = new Date(takenOn)
    month = monthNames[months.getMonth()]
    year = new Date(takenOn).getFullYear()
  }

  return (
    <PreviewPopupBase>
      <PreviewPopupHeader>
        <CloseButton onClick={props.onClose}>
          <CloseIcon viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <path
              d="M11.7674 10.0002L19.6338 2.13472C20.1221 1.64642 20.1221 0.854731 19.6338 0.366469C19.1455 -0.121831 18.3538 -0.121831 17.8655 0.366469L9.99997 8.23279L2.13447 0.366469C1.64617 -0.121831 0.854487 -0.121831 0.366225 0.366469C-0.122036 0.85477 -0.122075 1.64646 0.366225 2.13472L8.23254 10.0002L0.366225 17.8658C-0.122075 18.3541 -0.122075 19.1457 0.366225 19.634C0.854526 20.1223 1.64621 20.1223 2.13447 19.634L9.99997 11.7676L17.8655 19.634C18.3538 20.1223 19.1455 20.1223 19.6337 19.634C20.122 19.1457 20.122 18.354 19.6337 17.8658L11.7674 10.0002Z"
              fill="currentColor"
            />
          </CloseIcon>
        </CloseButton>
        <HeaderDate>
          <Icon icon={iconCalendar} size={14} style={{ marginRight: '9px' }} />
          {month && day && year && (
            <span>
              {month} {day}, {year}
            </span>
          )}
        </HeaderDate>
      </PreviewPopupHeader>
      <PreviewPopupImageWrap>
        {!props.imageLoading && (
          <>
            {imageUrl ? (
              <PreviewPopupImage src={imageUrl} alt="" />
            ) : (
              <EmptyPreviewPopupImage>No Image</EmptyPreviewPopupImage>
            )}
          </>
        )}
        {props.imageLoading && (
          <EmptyPreviewPopupImage>
            <LoadingIndicator />
          </EmptyPreviewPopupImage>
        )}
        <PreviewPopupIconButton onClick={props.onFullScreenClick}>
          <img src={iconExpand} alt="" />
        </PreviewPopupIconButton>
      </PreviewPopupImageWrap>
    </PreviewPopupBase>
  )
}
